var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('div',{attrs:{"justify":"center"}},[_c('img',{attrs:{"src":require('../assets/forbidden.svg'),"alt":"forbidden-svg"}}),_c('v-alert',{attrs:{"dense":"","prominent":"","type":"info"}},[_c('strong',[_vm._v("No cuentas con suficientes permisos para acceder a la aplicación.")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }